module.exports = __webpack_public_path__ + "static/media/haiwaisanhuisanbaoguanlixize.840d6172.png";